import { Factory } from 'rosie';

Factory.define('FbPageAccountSecretContent');

Factory.define('FbPageAccountSecretContentWithDefaults')
  .extend('FbPageAccountSecretContent')
  .attr('authToken', 'some-auth-token');



// WEBPACK FOOTER //
// ./factories/fb_page_account_secret_content_factory.js